/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import style from "./schemes.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import Loader from "../../components/loader/Loader";
const Schemes = () => {
  const [schemeData, setSchemeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      offset: 200,
    });
  }, []);

  // scheme api

  const handleSchemeData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/scheme",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      console.log("scheme response", response.data.data);
      setIsLoading(false);
      setSchemeData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleSchemeData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={`container-fluid ${style.scheme_container_fluid}`}>
          {/* banner row */}
          <div className="row">
            <div
              className={`col-lg-12 ps-0 pe-0 ${style.desktop_view_banner_row}`}
            >
              <div className={`${style.home_banner_sec}`}>
                <img
                  src={schemeData?.banner?.banner}
                  alt="banner"
                  loading="lazy"
                  className="img-fluid w-100"
                />
              </div>
            </div>
            {/* mobile view banner */}
            <div
              className={`col-lg-12 ps-0 pe-0 ${style.mobile_view_banner_row}`}
            >
              <div>
                <img
                  src={schemeData?.mobile_banner?.banner}
                  alt="banner"
                  loading="lazy"
                  className="img-fluid w-100"
                />
              </div>
            </div>
          </div>
          {/* Schemes row */}
          <header className={`${style.schemes_top_common_title_sec}`}>
            <span className={`${style.schemes_c_span_title}`}>Schemes</span>
            <h5 className={`${style.schemes_c_heading_title}`}>
              ग्रामपंचायत योजना
            </h5>
          </header>
          <div className={`row ${style.schemes_row}`}>
            {schemeData?.schemes?.map((ele) => {
              return (
                <div
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  key={ele.id}
                  className={`col-lg-3 col-md-6 ${style.scheme_col}`}
                >
                  <div className={`${style.scheme_card}`}>
                    <div className={`${style.card_img}`}>
                      <img
                        src={ele.image}
                        alt="schemes"
                        loading="lazy"
                        className="img-fluid w-100"
                      />
                    </div>
                    <div className={`${style.scheme_card_body}`}>
                      <p className={`${style.scheme_card_title}`}>
                        {ele.title}
                      </p>
                      <p
                        className={`${style.scheme_card_para}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                      {/* <div className={`${style.scheme_card_footer}`}>
                        <Link>More</Link>
                        <Link to="">
                          <BsArrowRight />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* client logos */}
          <div className={`row ${style.client_logo_row}`}>
            <div className="col-lg-12 ps-0 pe-0">
              <ul className={`${style.client_logo_ul_list}`}>
                {schemeData?.co_partner?.map((ele) => {
                  return (
                    <li key={ele.id} className={`${style.client_logo_list}`}>
                      <img
                        src={ele.image}
                        alt="client"
                        loading="lazy"
                        className="img-fluid"
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Schemes;
